export const NOT_ENROLLED = 'not-enrolled';
export const VARIATION = 'variation';

export const WHITEBOARDS_EXPAND_JIRAS_EXPERIMENT = 'grw_1037_expand_plan_in_whiteboards';

export const CTA_SOURCE_CONTEXT = 'planOnWhiteboardBacklogButton';
export const CTA_SOURCE_COMPONENT = 'planOnWhiteboardsButtonCTAScreen';

export type Flow = 'none' | 'crossFlow' | 'coUse';

export const WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS = {
	CONTEXT_MENU: 'variant_contextual_menu',
	BACKLOG_BUTTON: 'variant_backlog_button',
	CONTROL: 'control',
} as const;

export type WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS =
	(typeof WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS)[keyof typeof WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS];
